import types from '../types'
import Action from '../../types/Action'

const initialState = {
  loading: false,
  error: false,
  success: false,
  data: []
}

const wavierCompliantReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_WAVIER_COMPLIANT_REQUESTED: {
      return {
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
    case types.GET_WAVIER_COMPLIANT_FULFILLED: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload
      }
    }
    case types.GET_WAVIER_COMPLIANT_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    default:
      return state
  }
}

export default wavierCompliantReducer